// extracted by mini-css-extract-plugin
export default {"titleBig":"Typo_titleBig__qy51e","subtitle":"Typo_subtitle__XKcFO","contents":"Typo_contents__yU9f8"};